import { render, staticRenderFns } from "./CuponConsume.vue?vue&type=template&id=701446e4&scoped=true&"
import script from "./CuponConsume.vue?vue&type=script&lang=js&"
export * from "./CuponConsume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701446e4",
  null
  
)

export default component.exports